<template>
	<div
		v-if="titleDetailNode && title"
		style="position: relative"
		ref="container"
		:class="{
			'cinematic-v5': tvodCinematicActiveVariant === 'variant_5',
			'cinematic-v5--expanded': tvodCinematicActiveVariant === 'variant_5' && isV5Expanded,
		}"
	>
		<BuyBoxBanner
			v-if="!isTitleUpcoming"
			:offerCount="titleDetailNode.uniqueOfferCount"
			:offers="titleDetailNode.offers"
			:title="titleDetailNode"
			:seasonNumber="seasonNumber"
			:isAVODActive="!!AVODOffer"
			:additionalContexts="additionalContexts"
		/>
		<TVODHeroSection
			v-if="tvodCinematicActiveVariant"
			:title="titleDetailNode"
			:additionalContexts="additionalContexts"
			:useListBuybox="showNewBuyBox"
			:isV5Expanded="isV5Expanded"
		>
			<template>
				<TitleDetailJumpLinksV1
					:visibleSectionState="visibleSectionState"
					:container="container"
					:useListBuybox="showNewBuyBox"
				/>
			</template>
			<template #quickActionBar>
				<TitleDetailQuickActionBarV1
					v-if="titleDetailNode && isLoggedIn && tvodCinematicActiveVariant"
					class="title-detail__title hide-md"
					:titleObject="titleDetailNode"
					:influencedSponsoredAd="_sponsoredAd"
					layoutView="line"
				/>
			</template>
		</TVODHeroSection>

		<AVODHeroSection v-else-if="hasJWTVAVOD" :title="titleDetailNode" :additionalContexts="additionalContexts">
			<TitleDetailJumpLinksV1 :visibleSectionState="visibleSectionState" :container="container" />
		</AVODHeroSection>

		<!-- Default Hero - Priority 3 -->
		<TitleDetailHeroV1
			v-else
			:title="titleDetailNode"
			:additionalContexts="additionalContexts"
			:AVODOffer="AVODOffer"
			:isTitleUpcoming="isTitleUpcoming"
			:seasonName="seasonName"
			:activeClipId="activeClipId"
			:originalTitle="originalTitle"
			:isModal="!!entityId"
			:showChartInfo="hasNonCinemaOffers"
			@closeTitleDetailModal="emits('closeTitleDetailModal')"
			@setActiveClipId="activeClipId = $event"
		>
			<TitleDetailJumpLinksV1 :visibleSectionState="visibleSectionState" :container="container" />
		</TitleDetailHeroV1>

		<div
			class="title-detail"
			:class="{ 'new-buy-box': showNewBuyBox, 'no-alternate-rows': mergeBuyRentExpVariant === 'variant_3' }"
		>
			<div class="title-detail__content">
				<TitleDetailQuickActionBarV1
					v-if="titleDetailNode && isLoggedIn && !tvodCinematicActiveVariant"
					class="title-detail__title hide-md"
					:titleObject="titleDetailNode"
					:influencedSponsoredAd="_sponsoredAd"
					layoutView="line"
				/>

				<SectionContainer
					sectionId="season-list"
					v-if="isTitleShow(titleDetailNode) && titleDetailNode?.seasons?.length"
				>
					<div class="title-detail__title">
						<h2 class="title-detail__title__text">
							{{ $t('WEBAPP_X_SEASONS', { seasons: titleDetailNode.seasons.length }) }}
						</h2>
					</div>
					<LazySeasonListV1 :title="titleDetailNode" :additionalContexts="[]" />
				</SectionContainer>

				<SectionContainer sectionId="episodes-lists" v-if="(isShow || isSeason) && episodes.length">
					<div class="title-detail__title">
						<h2 class="title-detail__title__text">{{ episodesTitle }}</h2>
					</div>

					<!-- we need to block height because EpisodesList is async loaded -->
					<div style="width: 100%; min-height: 66px">
						<LazyEpisodesList
							:title="titleDetailNode"
							:titleId="titleId"
							:titleObjectId="titleObjectId"
							:titleName="titleName"
							:episodes="episodes"
							:maxEpisodes="maxEpisodes"
							:isTitleInWatchlist="isInWatchList"
							:additionalContexts="additionalContexts"
							:sponsoredAd="_sponsoredAd"
							:class="{ 'blocking-element': !titleDetailNode || episodes.length === 0 }"
						>
							<template #sponsoredRecommendation>
								<template v-if="(isListSponsoredAd || isShadowCampaign) && isSeason">
									<slot name="sponsoredRecommendation" placement="sr_title_detail" />
								</template>
								<SectionContainer
									sectionId="similar-content"
									v-else-if="hasActiveSRCampaign && isSeason"
								>
									<SimilarTitles
										:title="title"
										:sponsoredAd="_sponsoredAd"
										:additionalContexts="additionalContexts"
									>
										{{ $t('WEBAPP_SIMILARTITLES', { title: titleName }) }}

										<template #sponsoredRecommendation>
											<slot
												name="sponsoredRecommendation"
												placement="sr_title_detail_similar_titles"
											/>
										</template>
									</SimilarTitles>
								</SectionContainer>
							</template>
						</LazyEpisodesList>
					</div>
				</SectionContainer>
				<!-- VARIANT 5 -->
				<CinematicV5Hero
					v-if="tvodCinematicActiveVariant === 'variant_5'"
					ref="cinematicV5HeroRef"
					:title="titleDetailNode"
					:additionalContexts="additionalContexts"
					:expanded="isV5Expanded"
					:useListBuybox="showNewBuyBox"
					@expand="expandV5"
				/>

				<SectionContainer v-if="!isSeason" sectionId="where-to-watch">
					<UpcomingContent
						v-if="isTitleUpcoming && !showNewBuyBox"
						:title="titleDetailNode"
						:parentTitle="isTitleSeason(titleDetailNode) ? titleDetailNode.show : titleDetailNode"
						:isTitleInWatchlist="isInWatchList"
						:additionalContexts="additionalContexts"
						:showBuyBoxTypeSwitcher="!isSeason"
					/>

					<div v-else>
						<div id="buybox-anchor"></div>
						<KeepAlive>
							<ListBuyBox
								v-if="showNewBuyBox && titleDetailNode.id"
								:key="titleDetailNode.id"
								:buyboxOffers="buyboxOffers"
								:title="titleDetailNode"
								:sponsoredAd="_sponsoredAd"
								:additionalContexts="additionalContexts"
								:hidePromotedBuyBox="shouldHidePromotedBuyBox"
								@buyboxLoading="emits('buyboxLoading')"
							>
								<template #buybox-switcher v-if="overrideBuyBoxTypeActive">
									<BuyBoxTypeSwitcher
										:title="titleDetailNode"
										class="buybox-switcher-new"
										:additionalContexts="additionalContexts"
										@buyBoxTypeSwitched="updateOverrideBuyBoxType"
										v-bind="buyBoxTypeBindings"
								/></template>
							</ListBuyBox>
						</KeepAlive>

						<BuyBoxTypeSwitcher
							:title="titleDetailNode"
							v-if="
								!showNewBuyBox &&
								!shouldHidePromotedBuyBox &&
								hasPromotedOffers &&
								!isGridRedesignExpActive
							"
							class="buybox-switcher"
							:additionalContexts="additionalContexts"
							@buyBoxTypeSwitched="updateOverrideBuyBoxType"
							v-bind="buyBoxTypeBindings"
						/>

						<template v-if="!isTitleUpcoming && !showNewBuyBox">
							<LazyPromotedGridBuyBox
								v-if="!shouldHidePromotedBuyBox"
								:promotedOffers="promotedOffers"
								:promotedBundles="promotedBundles"
								:title="titleDetailNode"
								:titleId="titleDetailNode.id"
								:titleObjectType="titleDetailNode.objectType"
								:titleObjectId="titleDetailNode.objectId"
								:showDetails="showDetails"
								:seasonNumber="seasonNumber"
								:additionalContexts="additionalContexts"
								:sponsoredAd="_sponsoredAd"
								:titleNode="titleDetailNode"
							/>

							<KeepAlive>
								<GridBuyBox
									:key="titleDetailNode.id"
									:title="titleDetailNode"
									:titleId="titleDetailNode.id"
									:titleObjectId="titleDetailNode.objectId"
									:titleObjectType="titleDetailNode.objectType"
									:titleName="titleName"
									:originalReleaseYear="titleDetailNode.content.originalReleaseYear"
									:isTitleInWatchlist="isInWatchList"
									:additionalContexts="additionalContexts"
									:seasonNumber="seasonNumber"
									:titleScoring="titleDetailNode.content.scoring"
									showFilter
									:showDetails="showDetails"
									:sponsoredAd="_sponsoredAd"
									:isAVODActive="!!AVODOffer"
									@buyboxLoading="emits('buyboxLoading')"
									:isInModal="!!entityId"
								>
									<template #buybox-switcher>
										<BuyBoxTypeSwitcher
											:title="titleDetailNode"
											v-if="
												(shouldHidePromotedBuyBox || !hasPromotedOffers) &&
												!isGridRedesignExpActive
											"
											class="buybox-switcher-old"
											:additionalContexts="additionalContexts"
											@buyBoxTypeSwitched="updateOverrideBuyBoxType"
											v-bind="buyBoxTypeBindings"
										/>
									</template>
								</GridBuyBox>
							</KeepAlive>
						</template>
					</div>
					<CinematicV5ShowLess
						v-if="tvodCinematicActiveVariant === 'variant_5' && isV5Expanded"
						@collapse="collapseV5"
					/>
				</SectionContainer>

				<SectionContainer v-if="isSeason" sectionId="where-to-watch">
					<UpcomingContent
						v-if="isTitleUpcoming && !showNewBuyBox"
						:title="titleDetailNode"
						:parentTitle="isTitleSeason(titleDetailNode) ? titleDetailNode.show : titleDetailNode"
						:isTitleInWatchlist="isInWatchList"
						:additionalContexts="additionalContexts"
					/>

					<div v-else>
						<div id="buybox-anchor"></div>
						<KeepAlive>
							<ListBuyBox
								v-if="showNewBuyBox && titleDetailNode.id"
								:key="titleDetailNode.id"
								:title="titleDetailNode"
								:sponsoredAd="_sponsoredAd"
								:additionalContexts="additionalContexts"
								:buyboxOffers="buyboxOffers"
								:hidePromotedBuyBox="shouldHidePromotedBuyBox"
								@buyboxLoading="emits('buyboxLoading')"
							>
								<template #buybox-switcher v-if="overrideBuyBoxTypeActive">
									<BuyBoxTypeSwitcher
										:title="titleDetailNode"
										class="buybox-switcher-new"
										:additionalContexts="additionalContexts"
										@buyBoxTypeSwitched="updateOverrideBuyBoxType"
										v-bind="buyBoxTypeBindings"
								/></template>
							</ListBuyBox>
						</KeepAlive>

						<BuyBoxTypeSwitcher
							:title="titleDetailNode"
							v-if="!showNewBuyBox && !hidePromotedBuyBox && hasPromotedOffers"
							class="buybox-switcher"
							:additionalContexts="additionalContexts"
							@buyBoxTypeSwitched="updateOverrideBuyBoxType"
							v-bind="buyBoxTypeBindings"
						/>

						<template v-if="!isTitleUpcoming && !showNewBuyBox">
							<LazyPromotedGridBuyBox
								v-if="!hidePromotedBuyBox"
								:promotedOffers="promotedOffers"
								:promotedBundles="promotedBundles"
								:title="titleDetailNode"
								:titleId="titleDetailNode.id"
								:titleObjectType="titleDetailNode.objectType"
								:titleObjectId="titleDetailNode.objectId"
								:showDetails="showDetails"
								:seasonNumber="seasonNumber"
								:additionalContexts="additionalContexts"
								:sponsoredAd="_sponsoredAd"
								:titleNode="titleDetailNode"
							/>

							<KeepAlive>
								<GridBuyBox
									:key="titleDetailNode.id"
									:title="titleDetailNode"
									:titleId="titleDetailNode.id"
									:titleObjectId="titleDetailNode.objectId"
									:titleObjectType="titleDetailNode.objectType"
									:titleName="titleName"
									:originalReleaseYear="titleDetailNode.content.originalReleaseYear"
									:isTitleInWatchlist="isInWatchList"
									:additionalContexts="additionalContexts"
									:seasonNumber="seasonNumber"
									:titleScoring="titleDetailNode.content.scoring"
									showFilter
									:showDetails="showDetails"
									:sponsoredAd="_sponsoredAd"
									:isAVODActive="!!AVODOffer"
									@buyboxLoading="emits('buyboxLoading')"
									:isInModal="!!entityId"
								>
									<template #buybox-switcher>
										<BuyBoxTypeSwitcher
											:title="titleDetailNode"
											v-if="hidePromotedBuyBox || !hasPromotedOffers"
											class="buybox-switcher-old"
											:additionalContexts="additionalContexts"
										/>
									</template>
								</GridBuyBox>
							</KeepAlive>
						</template>
					</div>
				</SectionContainer>

				<template v-if="(isListSponsoredAd || isShadowCampaign) && !isSeason">
					<slot name="sponsoredRecommendation" placement="sr_title_detail" />
				</template>

				<!-- we show these similar titles higher up when there is a SR -->
				<!-- only display this row when a sponsoredAd is present -->
				<SectionContainer sectionId="similar-content" v-else-if="hasActiveSRCampaign && !isSeason">
					<SimilarTitles
						class="moved-up"
						:title="title"
						:sponsoredAd="_sponsoredAd"
						:additionalContexts="additionalContexts"
					>
						{{ $t('WEBAPP_SIMILARTITLES', { title: titleName }) }}

						<template #sponsoredRecommendation>
							<slot name="sponsoredRecommendation" placement="sr_title_detail_similar_titles" />
						</template>
					</SimilarTitles>
				</SectionContainer>

				<SpinningText
					class="spinning-texts"
					:title="titleDetailNode"
					:showRecentEpisodeList="true"
					v-if="!isLoggedIn"
					:hideSpinningText="showOffersHistory"
				>
					{{ metaData ? metaData.heading2 : 'Where to watch' }}
				</SpinningText>

				<StreamingOffersHistory
					v-if="showOffersHistory"
					:titleName="titleName"
					:titleObjectId="titleDetailNode.objectId"
					:titleObjectType="titleDetailNode.objectType"
					:offersHistory="titleDetailNode.offersHistory"
					:language="language"
					:country="country"
				/>
				<AdUnit adPosition="under_buybox" :subgenres="subgenres" />

				<SectionContainer sectionId="synopsis" v-if="editorialSynopsis || showSynopsis">
					<div class="title-detail__title">
						<h2 class="title-detail__title__text">{{ $t('WEBAPP_SYNOPSIS') }}</h2>
					</div>
					<ArticleBlock v-if="editorialSynopsis" :content="editorialSynopsis" />

					<TitleSynopsis
						v-else-if="showSynopsis"
						:shortDescription="titleDetailNode.content.shortDescription"
						:showSubheading="false"
					/>
				</SectionContainer>

				<SectionContainer
					sectionId="why-to-watch"
					v-if="(textRecommendationArray.length > 0 || showTextRecommendationTools) && isLoggedIn"
				>
					<div class="title-detail__title">
						<h2 class="title-detail__title__text">
							{{ $t('WEBAPP_WHY_TO_WATCH_TITLE_Q', { titleName }) }}
						</h2>
						<span
							v-if="showTextRecommendationTools && isLoggedIn"
							class="title-detail__title__action"
							@click="openTextRecommendationModal"
						>
							+ {{ $t('WEBAPP_ADD_WHY_TO_WATCH') }}
						</span>
					</div>
					<TextRecommendations :title="titleDetailNode" :additionalContexts="additionalContexts" />
				</SectionContainer>

				<SectionContainer sectionId="trailers" v-if="hasTrailers">
					<div id="clips_header">
						<div class="title-detail__title">
							<h2 class="title-detail__title__text">{{ $t('WEBAPP_TRAILERS') }}</h2>
						</div>
						<LazyTitleDetailTitleClipsV1
							:titleObjectType="titleDetailNode.objectType"
							:titleObjectId="titleDetailNode.objectId"
							:titleId="titleDetailNode.id"
							:clips="titleClips"
							:seasonNumber="seasonNumber"
							:episodeNumber="null"
							source="titledetail"
							:additionalContexts="additionalContexts"
							:influencedSponsoredAd="_sponsoredAd"
							:activeClipId="activeClipId"
							@setActiveClipId="activeClipId = $event"
						/>
					</div>
				</SectionContainer>

				<TitleDetailTitleSidebarV1
					:title="titleDetailNode"
					:additionalContexts="additionalContexts"
					:influencedSponsoredAd="_sponsoredAd"
					:showChartInfo="hasNonCinemaOffers"
					class="title-detail__sidebar"
				>
					<template #default>
						<div class="title-detail__title">
							<h2 class="title-detail__title__text title-detail__sidebar__title">
								{{ aboutHeadline }}
							</h2>
						</div>
					</template>

					<template #streamingCharts>
						<div v-if="displayStreamingChart && isLoggedIn" class="streaming-chart">
							<SectionContainer sectionId="streaming-chart">
								<LazyTitleDetailStreamingChart
									ref="streamingChart"
									:titleId="titleDetailNode?.id"
									:titleName="titleName"
									:streamingChartData="streamingCharts"
									:titleObjectType="titleDetailNode?.objectType"
								/>
							</SectionContainer>
						</div>
					</template>
				</TitleDetailTitleSidebarV1>

				<div v-if="displayStreamingChart && !isLoggedIn" class="streaming-chart">
					<SectionContainer sectionId="streaming-chart">
						<LazyTitleDetailStreamingChart
							ref="streamingChart"
							:titleId="titleDetailNode?.id"
							:titleName="titleName"
							:streamingChartData="streamingCharts"
							:titleObjectType="titleDetailNode?.objectType"
						/>
					</SectionContainer>
				</div>

				<TitleCredits :title="titleDetailNode" role="ACTOR" class="credits">
					{{ $t('WEBAPP_PERSONS_CREDITS') }}
				</TitleCredits>

				<AdUnit v-if="displayThirdAd" adPosition="bottom_page" :subgenres="subgenres" />

				<LazyTitleDetailSimilarTitlesV2
					v-if="showSimilarTitles && isLoggedIn"
					:title="titleDetailNode"
					:displaySimilarTitles="!(hasActiveSRCampaign && !isListSponsoredAd)"
					:genresByShortName="genresByShortName"
				/>
			</div>

			<!--
				after the ad on the right side (desktop) is displayed, we never use the space on the right.
				so we're now starting a new title-detail__content but with full-width.
			-->
			<div class="title-detail__content title-detail__content--full-width" v-if="!isLoggedIn">
				<LazyTitleDetailSimilarTitlesV2
					v-if="showSimilarTitles"
					:title="titleDetailNode"
					:displaySimilarTitles="!(hasActiveSRCampaign && !isListSponsoredAd)"
					:genresByShortName="genresByShortName"
				/>
			</div>
		</div>
		<AppFooter />

		<TextRecommendationModalV2
			v-if="displayTextRecommendationModal"
			:title="titleDetailNode"
			@close="closeTextRecommendationModal"
		/>
	</div>
</template>

<script lang="ts" setup>
import SimilarTitles from '@/components/SimilarTitles.vue';
import BuyBoxBanner from '@/features/buybox/components/BuyBoxBanner.vue';
import ListBuyBox from '@/features/buybox/components/list/ListBuyBox.vue';
import { TitleOfferFragment } from '@/features/buybox/graphql/fragments/Offer.fragment';
import { streamingChartCountries } from '@/components/details/streaming-chart/streaming-chart-config';
import type { AssertByTypename } from '@/helpers/graphql-model-helper';
import { type SnowplowContext } from '@/helpers/tracking/providers/snowplow-contexts';
import { TitleDetail } from '@/interfaces/title-details-graphql';
import type { SponsoredAdFragment } from '@/features/sponsored-recommendations/graphql/fragments/SponsoredAd.fragment';
import { GetNodeTitleDetailsQuery } from '@/pages/graphql/queries/GetNodeTitleDetails.query';
import SectionContainer from '@/pages/titleDetailV1/components/SectionContainer.vue';
import TitleDetailJumpLinksV1 from '@/pages/titleDetailV1/v1/TitleDetailJumpLinksV1.vue';
import {
	isTitleSeason,
	isTitleShow,
	useTitleDetailInfo,
} from '@/pages/titleDetailV1/v1/composables/useTitleDetailInfo';
import TitleDetailHeroV1 from '@/pages/titleDetailV1/v1/hero/TitleDetailHeroV1.vue';
import TitleDetailTitleSidebarV1 from '@/pages/titleDetailV1/v1/sidebar/TitleDetailTitleSidebarV1.vue';
import { NewBuyBoxView } from '@/stores/useUserStoreTypes';
import TitleDetailQuickActionBarV1 from '@/pages/titleDetailV1/v1/sidebar/TitleDetailQuickActionBarV1.vue';

import { computed, defineAsyncComponent, nextTick, provide, ref } from 'vue';

const AVODHeroSection = defineAsyncComponent(() => import('@/pages/titleDetailV1/v1/hero/AVODHeroSection.vue'));

const LazyTitleDetailTitleClipsV1 = defineLazyHydrationComponent(
	'visible',
	() => import('@/pages/titleDetailV1/v1/TitleDetailTitleClipsV1.vue')
);
const LazyTitleDetailStreamingChart = defineLazyHydrationComponent(
	'visible',
	() => import('@/components/details/streaming-chart/TitleDetailStreamingChart.vue')
);
const TitleSynopsis = defineAsyncComponent(() => import('@/components/details/TitleSynopsis.vue'));

const ArticleBlock = defineAsyncComponent(() => import('@/components/details/editorial/ArticleBlock.vue'));
const UpcomingContent = defineAsyncComponent(() => import('@/components/upcoming/UpcomingContent.vue'));
const LazyEpisodesList = defineLazyHydrationComponent('visible', () => import('@/components/EpisodesList.vue'));

const TitleCredits = defineAsyncComponent(() => import('@/components/details/TitleCredits.vue'));
const SpinningText = defineAsyncComponent(() => import('@/components/details/SpinningText.vue'));
const LazyTitleDetailSimilarTitlesV2 = defineLazyHydrationComponent(
	'visible',
	() => import('@/pages/titleDetailV1/v1/TitleDetailSimilarTitlesV2.vue')
);
const AdUnit = defineAsyncComponent(() => import('@/components/AdUnit.vue'));
// need to import these immediately because it's above the fold and could cause CLS
import BuyBoxTypeSwitcher from '@/features/buybox/components/BuyBoxTypeSwitcher.vue';
import GridBuyBox from '@/features/buybox/components/grid/GridBuyBox.vue';
const LazyPromotedGridBuyBox = defineLazyHydrationComponent(
	'visible',
	() => import('@/features/buybox/components/grid/PromotedGridBuyBox.vue')
);
import { TextRecommendationModalV2 } from '@/lazy-load-components';
import TextRecommendations from '@/features/why-to-watch/components/TextRecommendations.vue';
const LazySeasonListV1 = defineLazyHydrationComponent(
	'visible',
	() => import('@/pages/titleDetailV1/v1/SeasonListV1.vue')
);

import { ModuleContentStreamingCharts, MonetizationType, ObjectType, ProfileType } from '@/@types/graphql-types';
import { disableScroll, enableScroll } from '@/helpers/scroll-helper';
import { extractBuyboxOffers } from '@/helpers/title-helper';

import { useInternationalOffersStatus } from '@/features/international-offers/composables/useInternationalOffers';
import { useWtwTracking } from '@/features/why-to-watch/tracking';
import StreamingOffersHistory from '@/features/streaming-offers-history/components/StreamingOffersHistory.vue';
import { storeToRefs } from 'pinia';
import { useLanguageStore } from '@/stores/pinia/useLanguageStore';
import { useBuyBoxData } from '@/features/buybox/composables/useBuyboxData';
import { useUserStore } from '@/stores/pinia/useUserStore';
import { useActivateExperiment } from '@/libraries/experiment';
import { useBuyboxView } from '@/features/buybox/composables/useBuyboxView';
import { useArbitrage } from '@/helpers/composables/useArbitrage';
import { usePromotion } from '@/helpers/composables/usePromotion';
import { useSponsoredRec } from '@/features/sponsored-recommendations/composables/useSendBidId';
import { isJWTVRentalOffer } from '@/features/jwtv-titles-rental/helpers/jwtv-titles-rental-helper';
import { useJWTVCampaign } from '@/features/jwtv-titles-rental/composables/useJWTVCampaign';

const TVODHeroSection = defineAsyncComponent(
	() => import('@/components/experiments/JWTVTVODCinematicv2/components/TVODHeroSection.vue')
);
const CinematicV5Hero = defineAsyncComponent(
	() => import('@/components/experiments/JWTVTVODCinematicv2/components/CinematicV5Hero.vue')
);
const CinematicV5ShowLess = defineAsyncComponent(
	() => import('@/components/experiments/JWTVTVODCinematicv2/components/CinematicV5ShowLess.vue')
);
const activeClipId = ref<string | null>(null);
const streamingChart = ref<{ renderChart?: boolean } | null>(null);
const container = ref(null);
const displayTextRecommendationModal = ref<boolean>(false);

const { newBuyboxView, buyboxExpView, isAdmin, isEditor, loggedInNewBuyboxView, isLoggedIn } = storeToRefs(
	useUserStore()
);

const { country, language } = storeToRefs(useLanguageStore());
const { t } = useI18n();

const emits = defineEmits(['buyboxLoading', 'closeTitleDetailModal']);
const props = withDefaults(
	defineProps<{
		titleDetailNode: AssertByTypename<GetNodeTitleDetailsQuery['node'], 'Movie' | 'Show' | 'Season'> | undefined;
		promotedOffers?: TitleOfferFragment[];
		metaData: any;
		genresByShortName: any;
		hidePromotedBuyBox: boolean;
		_sponsoredAd: SponsoredAdFragment | undefined;
		entityId?: string | undefined;
		isLoading?: boolean;
		isPerceivedLoading: boolean;
		additionalContexts?: SnowplowContext[];
		isAVODActive?: boolean;
	}>(),
	{
		promotedOffers: () => [],
		additionalContexts: () => [],
		_sponsoredAd: undefined,
	}
);

const {
	title,
	titleName,
	titleId,
	titleObjectId,
	seasonName,
	seasonNumber,
	seasonTotalEpisodeCount,
	isShow,
	isSeason,
	recentEpisodes,
	recentEpisodesAvailable,
	isTitleUpcoming,
	showDetails,
	originalTitle,
	isInWatchList,
} = useTitleDetailInfo(() => props.titleDetailNode);

const {
	isActive: isInternationalOffersActive,
	hasInternationalOffers,
	isInternationalOffersTitle,
} = useInternationalOffersStatus({
	title: () => props.titleDetailNode,
});

const { AVODOffer, upcomingReleases } = useBuyBoxData({
	title: () => props.titleDetailNode as TitleDetail,
	buyboxUpcomingReleases: () => props.titleDetailNode?.content?.upcomingReleases ?? [],
});

const { isArbitrating } = useArbitrage();

// Grid Swiper Exp
const activateExpGridSwiper = computed(
	() =>
		!isArbitrating.value &&
		!!props.titleDetailNode &&
		!props.titleDetailNode.offers.some(offer => ['amp', 'hlu'].includes(offer.package.shortName))
	// exclude Prime and Hulu titles, because these are not compatible with the Prime SQTV / Hulu QTV placements
);
useActivateExperiment('EXP_GRID_SWIPER', activateExpGridSwiper);

const { inPromotionCatalogue, catalogueItem } = usePromotion({
	offers: () => props.titleDetailNode?.offers ?? [],
	title: () => props.titleDetailNode,
});

// Grid Swiper Exp
const activatePreRollExp = computed(
	() => !isArbitrating.value && !!props.titleDetailNode && !inPromotionCatalogue.value
);
useActivateExperiment('EXP_PRE_ROLL_GRID', activatePreRollExp);
// Grid Redesign Exps
const activateGridRedesignExps = computed(
	() => !isArbitrating.value && !!props.titleDetailNode && props.titleDetailNode.objectType === ObjectType.Movie
);

const { activeVariantWithControlGroup: gridRedesignClickActiveVariant } = useActivateExperiment(
	'EXP_GRID_REDESIGN_CLICK',
	activateGridRedesignExps
);

const { activeVariantWithControlGroup: gridMoreInfoActiveVariant } = useActivateExperiment(
	'EXP_GRID_REDESIGN_MORE_INFO',
	activateGridRedesignExps
);

const isGridRedesignExpActive = computed(
	() => !!gridRedesignClickActiveVariant.value || !!gridMoreInfoActiveVariant.value
);

// EXP MERGE BUY RENT
const activateMBRExp = computed(() => {
	return !isInternationalOffersActive.value && upcomingReleases.value.length === 0 && !isArbitrating.value;
});
const { activeVariantWithControlGroup: mergeBuyRentExpVariant } = useActivateExperiment(
	'EXP_MERGE_BUY_RENT',
	activateMBRExp
);
// EXP MERGE BUY RENT

// Apple Binge Exp
const activateAppleBingeExp = computed(
	() => !!props.titleDetailNode && !props.titleDetailNode.offers.some(offer => offer.package.shortName === 'atp')
);
useActivateExperiment('EXP_APPLE_BINGE_2', activateAppleBingeExp);

// Important - declare Grid bbox experiments before useBuyboxView, as experiments affect the return value of useBuyboxView

// OLD BUYBOX EXP
const { isGridBuyboxDefault } = useBuyboxView({ objectType: () => props.titleDetailNode?.objectType });
// OLD BUYBOX EXP

const activatePrimePlayPromoExp = computed(() => {
	return (
		!!props.titleDetailNode &&
		(props.titleDetailNode.offers ?? []).some(offer => offer.package.shortName === 'amp') &&
		catalogueItem.value?.shortName === 'amp'
	);
});

useActivateExperiment('EXP_PRIME_PLAY_PROMO', activatePrimePlayPromoExp);

// only countries that are enabled for international offers get the noOffer prop filled
provide('noOffer', isInternationalOffersActive.value);

const buyboxOffers = computed(() => {
	if (!props.titleDetailNode) {
		return null;
	}
	return extractBuyboxOffers(props.titleDetailNode);
});

const { isListSponsoredAd, isShadowCampaign, hasActiveSRCampaign } = useSponsoredRec({
	sponsoredAd: () => props._sponsoredAd ?? null,
	objectType: () => props.titleDetailNode?.objectType ?? null,
});

const streamingCharts = computed(() => {
	const streamingChartsModule = props.titleDetailNode?.titleModules.find(
		module => module?.template.technicalName === 'TITLE_STREAMING_CHARTS'
	);
	return (streamingChartsModule?.content as ModuleContentStreamingCharts)?.Titles ?? [];
});

const hasNonCinemaOffers = computed(
	() => !!props.titleDetailNode?.offers.some(offer => offer.monetizationType !== MonetizationType.Cinema)
);

// here we only check if the current title has any streaming charts informations.
// it won't have informations about titles up or below the title's streaming charts' rank.
const displayStreamingChart = computed(() => {
	if (!streamingChartCountries.includes(country.value) || !props.titleDetailNode?.streamingCharts) {
		return false;
	}

	// temporary hack for broken ES logic
	if (!hasNonCinemaOffers.value) return false;

	const rank = props.titleDetailNode?.streamingCharts.edges?.[0]?.streamingChartInfo?.rank;
	return !!rank && rank < 10000;
});

const hasJWTVAVOD = computed(() => {
	const offers = props.titleDetailNode?.justwatchTVOffers;
	if (!offers || offers.length === 0) return false;

	return offers[0].monetizationType === MonetizationType.Free && offers[0].package.technicalName === 'justwatchtv';
});

const overrideExpBuyBoxType = ref<NewBuyBoxView>(hasJWTVAVOD.value ? NewBuyBoxView.LIST : NewBuyBoxView.GRID);

const overrideBuyBoxTypeActive = computed(() => hasJWTVAVOD.value && !isLoggedIn.value);

const buyBoxTypeBindings = computed(() =>
	overrideBuyBoxTypeActive.value ? { buyBoxType: overrideExpBuyBoxType.value } : {}
);

function updateOverrideBuyBoxType(view: { buyBoxType: NewBuyBoxView }) {
	if (!overrideBuyBoxTypeActive.value) return;
	overrideExpBuyBoxType.value = view.buyBoxType;
}

const showSynopsis = computed(
	() =>
		!(
			props.metaData?.htmlContentJson?.detail_heading != null &&
			props.metaData?.htmlContentJson?.detail_content != null
		) && !!props.titleDetailNode?.content?.shortDescription
);

const editorialSynopsis = computed(() => props.titleDetailNode?.content?.editorialContent?.synopsis ?? null);

const showSimilarTitles = computed(() => !!props.titleDetailNode && !props.metaData?.htmlContent.hide_similar_titles);

const aboutHeadline = computed(() => {
	return isSeason.value
		? t('WEBAPP_ABOUT_THE_SEASON')
		: isShow.value
		? t('WEBAPP_ABOUT_THE_TV_SHOW')
		: t('WEBAPP_ABOUT_THE_MOVIE');
});

const showNewBuyBox = computed(() => {
	if (!!overrideBuyBoxTypeActive.value) {
		return overrideExpBuyBoxType.value !== NewBuyBoxView.GRID;
	}

	// MERGE BUY RENT EXP
	if (!!mergeBuyRentExpVariant.value) return true;
	// MERGE BUY RENT EXP

	if (isInternationalOffersTitle.value) {
		return true;
	}

	// OLD BUYBOX EXP
	if (isGridBuyboxDefault.value) {
		return buyboxExpView.value !== NewBuyBoxView.GRID;
	}
	// OLD BUYBOX EXP

	if (isLoggedIn.value && (isSeason.value || isShow.value)) {
		return loggedInNewBuyboxView.value !== NewBuyBoxView.GRID;
	}

	return newBuyboxView.value !== NewBuyBoxView.GRID;
});

const showOffersHistory = computed(
	() =>
		!isLoggedIn.value &&
		!!props.titleDetailNode?.offersHistory?.length &&
		props.titleDetailNode.offersHistory.length > 0 &&
		!hasInternationalOffers.value
);

const episodesTitle = computed(() => {
	// only show this for now for show page release - tbc
	if (isSeason.value) return t('WEBAPP_X_EPISODES', { episodes: seasonTotalEpisodeCount.value || '' });
	return t('WEBAPP_WATCH_NEWEST_EPISODES');
	// return recentEpisodesAvailable.value ? t('WEBAPP_RECENT_EPISODES') : t('WEBAPP_WATCH_NEWEST_EPISODES');
});

const maxEpisodes = computed(() =>
	recentEpisodesAvailable.value ? recentEpisodes.value.length : seasonTotalEpisodeCount.value
);

const episodes = computed(() =>
	recentEpisodesAvailable.value
		? recentEpisodes.value
		: (props.titleDetailNode as AssertByTypename<GetNodeTitleDetailsQuery['node'], 'Season'>).episodes || []
);

const showTextRecommendationTools = computed(() => isAdmin.value || isEditor.value);

/* Ads */

// we don't want to display too many ads in one viewport.
// that's why we're taking out the 3rd ad slot, if it's:
// - on a page without streaming charts (that would push down the content vertically)
// - only in DE
const subgenres = computed(() => props.titleDetailNode?.content.subgenres ?? []);

const displayThirdAd = computed(() => {
	return !['DE'].includes(country.value) || displayStreamingChart.value;
});

/* Clips */

const titleClips = computed(() => {
	// check for localised trailers, if not use fallbacks
	const localisedClips = getTitleClips(props.titleDetailNode, 'content');
	if (localisedClips.length) return localisedClips;

	return getTitleClips(props.titleDetailNode, 'fallBackClips');
});

const hasTrailers = computed(() => titleClips.value.length > 0);

function getTitleClips(titleNode: typeof props.titleDetailNode, key: 'content' | 'fallBackClips') {
	const youtubeClips = titleNode?.[key]?.clips ?? [];
	if (youtubeClips.length) return youtubeClips;

	const dailymotionClips = titleNode?.[key]?.dailymotionClips ?? [];
	return dailymotionClips.length ? [dailymotionClips[0]] : [];
}

const { trackWtw } = useWtwTracking({ title: () => props.titleDetailNode });

const promotedBundles = computed(() => props.titleDetailNode?.promotedBundles ?? []);
const hasPromotedOffers = computed(() => props.promotedOffers.length + promotedBundles.value.length > 0);

function openTextRecommendationModal() {
	// if (preventNonSignedInAction(AccountModes.REGISTRATION_OPTIONS)) return;

	trackWtw('modalOpened');

	displayTextRecommendationModal.value = true;
	disableScroll();
}

function closeTextRecommendationModal() {
	displayTextRecommendationModal.value = false;
	enableScroll();
}

const textRecommendationArray = computed(() => {
	const textRecs = props.titleDetailNode?.content?.textRecommendations ?? [];

	if (isLoggedIn.value) return textRecs;

	// hide user text recommendations for non-logged-in users, for SEO
	return textRecs.filter(textRec => ![ProfileType.User, ProfileType.ProUser].includes(textRec.profile.profileType));
});

const visibleSectionState = computed(() => {
	return {
		trailers: !!(hasTrailers.value && props.titleDetailNode),
		'why-to-watch': textRecommendationArray.value?.length > 0 && isLoggedIn.value,
		synopsis: showSynopsis.value || editorialSynopsis != null,
		'streaming-chart': displayStreamingChart.value && !!streamingChart.value?.renderChart,
		'episodes-lists': !isTitleUpcoming.value && (isSeason.value || isShow.value),
		'regular-buybox': !(isTitleUpcoming.value && !showNewBuyBox.value),
		'similar-content': showSimilarTitles.value,
	};
});

// EXP_JWTV_TVOD_CINEMATIC_V2
const hasJWTVRentalOffer = computed(() => {
	const jwtvOffer = props.titleDetailNode?.rent.find(offer => offer.package.shortName === 'jwt');
	return jwtvOffer && isJWTVRentalOffer(jwtvOffer);
});
const { hasActiveJwtvCampaign } = useJWTVCampaign();
const isExperimentActive = computed(
	() => !isInternationalOffersActive.value && !!hasJWTVRentalOffer.value && !hasActiveJwtvCampaign.value
);

const { activeVariant: tvodCinematicActiveVariant, trackEvent: trackCinematicEvent } = useActivateExperiment(
	'EXP_JWTV_TVOD_CINEMATIC_V2',
	isExperimentActive
);

const shouldHidePromotedBuyBox = computed(
	() => props.hidePromotedBuyBox || tvodCinematicActiveVariant.value === 'variant_1'
);

const isV5Expanded = ref(false);
const cinematicV5HeroRef = ref<{ $el: HTMLElement } | null>(null);

function collapseV5() {
	trackCinematicEvent({ action: 'click', label: 'less_options', value: showNewBuyBox.value ? 1 : 0 });
	isV5Expanded.value = false;
	nextTick(() => {
		cinematicV5HeroRef.value?.$el?.scrollIntoView({ behavior: 'smooth', block: 'start' });
	});
}

function expandV5() {
	trackCinematicEvent({ action: 'click', label: 'more_options', value: showNewBuyBox.value ? 1 : 0 });
	isV5Expanded.value = true;
	nextTick(async () => {
		await new Promise(resolve => setTimeout(resolve, 100));
		cinematicV5HeroRef.value?.$el?.scrollIntoView({ behavior: 'smooth', block: 'start' });
	});
}
</script>

<style lang="scss" scoped>
.title-detail {
	padding: 0 64px;
	max-width: 100%;
	display: flex;
	flex-direction: column;

	column-gap: 48px;
	--spacing-08: 32px;

	@media (max-width: 1050px) {
		padding: 0 16px;
		display: flex;
		flex-direction: column;
		--spacing-08: 24px;
	}

	@media (min-width: 1440px) {
		max-width: 1440px;
		margin-inline-start: auto;
		margin-inline-end: auto;
	}

	.buybox-container {
		margin: var(--spacing-08) 0 !important;
		width: 100% !important;
		padding: 0 !important;
		:deep(.buybox-container__header__text) {
			margin: 0;
		}
	}

	:deep(.buybox-container__header__text),
	:deep(.offers-grid__heading__text),
	:deep(.buybox__heading__text),
	:deep(.upcoming-content__heading__text) {
		-webkit-font-smoothing: antialiased;
		font-family: Anton, Anton-Fallback, Impact;
		font-size: 22px;
		font-weight: 400;
		line-height: 32px;
		margin-block: var(--spacing-08) 16px;
	}
	:deep(.offers-grid__heading__text),
	:deep(.buybox__heading__text) {
		margin: 0;
	}
	:deep(.upcoming-content__heading__text) {
		margin-top: 0;
	}
	:deep(.upcoming-content__heading) {
		margin-block: var(--spacing-08);
	}
	:deep(.buybox__heading__text) {
		color: #fff;
	}
	:deep(.spinning-texts h2),
	:deep(.credits .detail-infos__subheading--label),
	:deep(.similar-titles .detail-infos__subheading--label),
	:deep(.guide-list) .heading.guide-list__heading {
		-webkit-font-smoothing: antialiased;
		font-family: Anton, Anton-Fallback, Impact;
		font-size: 22px;
		font-weight: 400;
		line-height: 32px;
		letter-spacing: 0.02em;
		color: #ffffff;
		text-transform: uppercase;
		margin-block: var(--spacing-08) 16px;
	}

	:deep(.similar-titles) {
		margin-bottom: 0px;
		.horizontal-title-list,
		.detail-infos__subheading {
			margin: 0;
		}
	}

	.article-block {
		margin-block: 0;
	}

	.streaming-chart {
		position: relative;
	}

	&__content {
		max-width: 100%;
		position: relative;
		display: grid;
		grid-template-columns: minmax(0, 3fr) 368px;
		column-gap: 48px;

		& > *:not(.title-detail__sidebar) {
			grid-column: 1;
		}

		// TOO CLOSE TO THE BUYBOX
		&::v-deep {
			.sponsored-recommendation--TITLELIST {
				margin-top: 24px;
			}
		}

		&__similar-titles {
			@media (max-width: 1050px) {
				display: none;
			}
		}

		&--full-width {
			grid-template-columns: minmax(0, 3fr);
		}

		@media (max-width: 1050px) {
			display: flex;
			flex-direction: column;
		}
	}

	&__sidebar {
		display: flex;
		flex-direction: column;
		grid-column: 2;
		grid-row: 1/100;
	}
	&.new-buy-box {
		@media (max-width: 1050px) {
			padding: 0 16px;
			display: flex;
			flex-direction: column;
			--spacing-08: 24px;
		}
		&__content,
		&__sidebar {
			&__similar-titles {
				@media (min-width: 1050px) {
					display: none;
				}
			}
		}
	}

	:deep(.offers-grid__heading),
	:deep(.buybox__heading) {
		margin-block: var(--spacing-08) 16px;
	}
	// :deep(.detail-infos__subheading--label) {
	// 	margin-block: 24px 8px;
	// }

	&__title {
		display: flex;
		justify-content: space-between;
		align-items: center;
		margin-block: var(--spacing-08) 16px;

		@media (max-width: 1050px) {
			flex-direction: column;
			align-items: start;
		}

		&__text {
			-webkit-font-smoothing: antialiased;
			font-family: Anton, Anton-Fallback, Impact;
			font-size: 22px;
			font-weight: 400;
			line-height: 32px;
			letter-spacing: 0.02em;
			color: #ffffff;
			text-transform: uppercase;
			margin: 0;

			&--icon {
				margin-inline-start: 5px;
				color: #6f7d90;

				&:hover {
					cursor: pointer;

					& + .popover {
						display: block;
					}
				}
			}
		}

		&__action {
			color: var(--link-link-medium, #78a6b8);
			font-size: 16px;
			font-style: normal;
			font-weight: 400;
			line-height: 16px;
			letter-spacing: 0.24px;

			@media (max-width: 1050px) {
				margin-top: 8px;
			}

			&:hover {
				text-decoration: underline;
				cursor: pointer;
			}
		}

		&.hide-md {
			@media (min-width: 1050px) {
				display: none;
			}
		}
	}
}
.accordion {
	margin-top: var(--spacing-08);
}

.popover {
	position: absolute;
	margin-top: 5px;
	display: none;
	height: fit-content;
	max-width: 350px;
	left: 200px;
	padding: 24px;
	background-color: #222c38;
	z-index: 11;

	@media (max-width: 550px) {
		max-width: 100%;
		right: 0;
		margin: 0 10px;
		margin-top: 5px;
	}

	p {
		text-transform: initial;
		margin: 0;
		font-size: 16px;
		font-weight: 400;
		line-height: 24px;
	}
}

.buybox-switcher {
	margin-top: 30px;
	margin-bottom: -65px;
	@media (max-width: 550px) {
		margin-bottom: -55px;
	}
}

.below-promoted-buybox {
	margin-top: -16px;
}

// EXP MERGE BUY RENT
.no-alternate-rows {
	:deep(.offer-container) {
		background: #0c131e !important;

		&:not(:last-child) {
			margin-bottom: 4px;
		}
	}
}
// EXP MERGE BUY RENT

// EXP_JWTV_TVOD_CINEMATIC_V2 variant_5
.cinematic-v5:not(.cinematic-v5--expanded) {
	::v-deep #where-to-watch {
		display: none;
	}
}

.cinematic-v5.cinematic-v5--expanded {
	::v-deep #where-to-watch {
		background: #ffffff0a;
		border-radius: 0px 0px 8px 8px;
		padding: 0 16px 16px 16px;
		.buybox-container {
			margin-top: 24px !important;
		}
		.buybox-filter__label:not(.buybox-filter__label--active) {
			background: #0c131d;
		}
		.buybox-type-switcher__button:not(.active) {
			background: #0c131d;
		}
		.buybox-selector.buybox {
			overflow: hidden;
			border: 1px solid rgba(255, 255, 255, 0.08);
		}
	}
}
</style>
